module.exports = __webpack_public_path__ + "static/images/tiaoxingma.2e42a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tiaoxingma.png
// module id = ouZo
// module chunks = 0